(function(){
  window.pwAddToCart = window.pwAddToCart || function(variantId, qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:qty||1}]})})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        var d=document.querySelector('cart-drawer');
        if(d){ if(typeof d.show==='function'){ d.show(); } else { d.setAttribute('open',''); } }
        else { window.location.href='/cart'; }
      });
  };
  document.addEventListener('click', function(e){
    var b = e.target.closest('.pw-card__button[data-pw-add]');
    if(!b) return;
    e.preventDefault();
    if(b.disabled) return;
    var t = b.textContent; b.disabled = true; b.textContent = 'Adding…';
    window.pwAddToCart(b.getAttribute('data-pw-add'), 1)
      .then(function(){ b.textContent = t; b.disabled = false; })
      .catch(function(){ b.textContent = t; b.disabled = false; window.location.href = '/products/' + (b.closest('.pw-card')||{}).getAttribute('data-product-handle'); });
  });
})();
